import { patientStatusEnum } from "beitary-shared";
import { BSelect } from "components/BSelect";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface PatientStatusSelectProps {
  required?: boolean;
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
}

export const PatientStatusSelect = (props: PatientStatusSelectProps) => {
  const { t } = useTranslation();

  const data = patientStatusEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return (
    <BSelect
      {...props}
      data={data}
      nothingFound={t("NOTHING_FOUND")}
      label={t("STATUS")}
    />
  );
};
